import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { organisationOnBoardedGuard } from './core/organisation/guards/organisation-onboarded.guard';
import { organisationGuard } from './core/organisation/guards/organisation.guard';
import { organisationNotOnBoardedGuard } from './core/organisation/guards/organisation-not-onboarded.guard';
import { Error500Component } from './core/error/error-500/error-500.component';
import { Error404Component } from './core/error/error-404/error-404.component';
import { CreateOrganisationComponent } from './modules/create-organisation/create-organisation.component';
import { SubscriptionGuard } from './core/auth/guards';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

   
    {path: '', pathMatch : 'full', redirectTo: 'home'},


   
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'home'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            {path: 'invite', loadChildren: () => import('app/modules/auth/invite/invite.routes')},
            {
                path: 'email/verify/:userId/:token',
                loadChildren: () => import('app/modules/auth/verify-email/verify-email.routes')
            },
            {
                path: 'proposals',
                loadChildren: () => import('app/modules/proposal-public/proposal-public.routes')
            },
            // client auth route
            {
                path: 'client-auth',
                loadChildren: () => import('app/modules/client-auth/client-auth.routes')
            },
            // payment routes (accessible to guests for Stripe redirects)
            // {
            //     path: 'payment',
            //     loadChildren: () => import('app/modules/payment/payment.routes')
            // }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        canActivate: [AuthGuard],
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
            {path: '404', loadChildren: () => import('app/core/error/error-404/error-404.routes')},
            {path: '500', loadChildren: () => import('app/core/error/error-500/error-500.routes')},
            {path: 'user', 
                loadChildren: () => import('app/modules/user/user.routes')
            },
            {
                path: 'create-organisation',
                loadChildren: () => import('app/modules/create-organisation/create-organisation.routes')
            },
            {
                path: 'invite/:token/accept',
                data: {
                    authenticated: true
                },
                loadComponent: () => import('app/modules/auth/invite/invite.component').then(m => m.InviteComponent)
            },
            {
                path: 'proposals/:proposalUUID/accept',
                data: {
                    authenticated: true
                },
                loadComponent: () => import('app/modules/proposal-public/proposal-public.component').then(m => m.ProposalPublicComponent)
                
            },
            {
                path: 'payment',
                loadChildren: () => import('app/modules/payment/payment.routes')
            },
            {
                path: 'access-denied',
                loadChildren: () => import('app/modules/payment/contact-admin/contact-admin.routes')
            }
            
        ]
    },

    // {
    //     path: '',
    //     canActivate: [AuthGuard, organisationGuard],
    //     canActivateChild: [AuthGuard],
    //     component: LayoutComponent,
    //     children: [
    //         {
    //             path: 'user',
    //             loadChildren: () => import('app/modules/user/user.routes')
    //         }
    //     ]   
    // },

    // Organisation routes
    {
        path: ':organisationSlug',
        canActivate: [AuthGuard, organisationGuard],
        canActivateChild: [AuthGuard],
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
            {   
                path: 'onboard', 
                component: LayoutComponent,
                data: {
                    layout: 'empty'
                },
                loadChildren:() => import('app/modules/onboard/onboard.routes'),
                canActivate: [organisationNotOnBoardedGuard]
            },

            {
                path: '', 
                component: LayoutComponent,
                resolve: {
                    initialData: initialDataResolver
                },
                loadChildren: () => import('app/modules/organisation/organisation.routes'), 
                canActivate: [organisationOnBoardedGuard]
            }
        ]
    },

    // // onboard route
    // {
    //     path: ':organisationSlug',
    //     component: LayoutComponent,
    //     data: {
    //         layout: 'empty'
    //     },
    //     children: [
    //         {path: 'onboard', loadChildren: () => import('app/modules/onboard/onboard.routes')}
    //     ]
    // }
];
